var _circle, _path, _rect, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldGaelic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 130 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.9897,
    cy: 61.7553,
    r: 56.7553,
    fill: "#D9D9D9",
    stroke: "url(#paint0_linear_2242_68)",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.07 58.2842C79.8586 58.2842 87.7939 50.7666 87.7939 41.4932C87.7939 32.2198 79.8586 24.7021 70.07 24.7021C60.2814 24.7021 52.3462 32.2198 52.3462 41.4932C52.3462 50.7666 60.2814 58.2842 70.07 58.2842ZM54.1904 66.6791C40.9356 66.6791 30.1904 77.4243 30.1904 90.6791V96.0635H109.948V90.6791C109.948 77.4243 99.2025 66.6791 85.9476 66.6791H54.1904Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 96.5635,
    width: 138.979,
    height: 31.9362,
    rx: 9.5,
    fill: "white",
    stroke: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5125 111.909C70.5125 112.996 70.3137 113.931 69.9159 114.713C69.5182 115.492 68.973 116.092 68.2803 116.513C67.5909 116.93 66.807 117.139 65.9287 117.139C65.0471 117.139 64.2599 116.93 63.5672 116.513C62.8778 116.092 62.3343 115.49 61.9365 114.708C61.5388 113.926 61.3399 112.993 61.3399 111.909C61.3399 110.822 61.5388 109.889 61.9365 109.11C62.3343 108.328 62.8778 107.728 63.5672 107.31C64.2599 106.889 65.0471 106.679 65.9287 106.679C66.807 106.679 67.5909 106.889 68.2803 107.31C68.973 107.728 69.5182 108.328 69.9159 109.11C70.3137 109.889 70.5125 110.822 70.5125 111.909ZM68.9912 111.909C68.9912 111.08 68.857 110.383 68.5885 109.816C68.3234 109.246 67.9588 108.815 67.4948 108.523C67.0341 108.228 66.512 108.081 65.9287 108.081C65.3421 108.081 64.8184 108.228 64.3577 108.523C63.897 108.815 63.5324 109.246 63.2639 109.816C62.9988 110.383 62.8662 111.08 62.8662 111.909C62.8662 112.738 62.9988 113.437 63.2639 114.007C63.5324 114.574 63.897 115.005 64.3577 115.3C64.8184 115.591 65.3421 115.737 65.9287 115.737C66.512 115.737 67.0341 115.591 67.4948 115.3C67.9588 115.005 68.3234 114.574 68.5885 114.007C68.857 113.437 68.9912 112.738 68.9912 111.909ZM65.347 105.799L63.8108 103.507H65.3769L66.5352 105.799H65.347ZM72.3085 117V109.364H73.7453V110.577H73.8248C73.964 110.166 74.2093 109.843 74.5606 109.607C74.9153 109.369 75.3163 109.249 75.7638 109.249C75.8566 109.249 75.9659 109.253 76.0919 109.259C76.2211 109.266 76.3222 109.274 76.3952 109.284V110.706C76.3355 110.689 76.2294 110.671 76.077 110.651C75.9245 110.628 75.772 110.616 75.6196 110.616C75.2683 110.616 74.955 110.691 74.68 110.84C74.4082 110.986 74.1927 111.19 74.0336 111.452C73.8746 111.71 73.795 112.005 73.795 112.337V117H72.3085Z",
    fill: "#0065BD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2242_68",
    x1: 69.9897,
    y1: 0,
    x2: 69.9897,
    y2: 123.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0CD16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A760D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldGaelic);
export default __webpack_public_path__ + "static/media/gold-gaelic.8ef4ae7db0dce14fdb821872f73967aa.svg";
export { ForwardRef as ReactComponent };